import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router } from '@angular/router';
import { ClientService } from '../../core/services/client.service';
import { Client } from '../../core/models/client.model';
import { HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { NgIf } from '@angular/common';
import { ClientFormBaseComponent } from '../client-form-base.component';

@Component({
  selector: 'app-client-create',
  templateUrl: './client-create.component.html',
  styleUrls: ['./client-create.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule, HttpClientModule, NgIf],
})
export class ClientCreateComponent extends ClientFormBaseComponent {
  constructor(
    protected override fb: FormBuilder,
    private clientService: ClientService,
    private router: Router,
  ) {
    super(fb);
  }

  onSubmit(): void {
    if (this.clientForm.valid) {
      const newClient: Client = this.clientForm.value;
      this.clientService.createClient(newClient).subscribe({
        next: response => {
          console.log('Cliente agregado:', response);
          this.router.navigate(['/clients']);
        },
        error: (error: HttpErrorResponse) => {
          console.error('Error al agregar el cliente:', error);
          this.errorMessage = error.error || 'Ocurrió un error desconocido';
        },
        complete: () => {
          console.log('Solicitud de creación de cliente completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }
}
